var React = require('react');

function Home32x32 (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M8.90234 28.4992C6.90234 28.4992 6.00234 26.7992 5.90234 25.5992V14.2992H8.80234V25.3992C8.80234 25.4992 8.90234 25.5992 8.90234 25.6992H22.8023C22.8023 25.6992 23.0023 25.5992 23.1023 25.5992V14.1992H26.0023V25.4992C26.0023 27.5992 24.2023 28.4992 23.0023 28.4992H8.90234Z","key":0}),React.createElement("path",{"d":"M27.2016 18.5998L15.9016 7.2998L4.70156 18.5998L2.60156 16.5998L15.9016 3.2998L29.2016 16.5998L27.2016 18.5998Z","key":1})]);
}

Home32x32.defaultProps = {"viewBox":"0 0 32 32","fill":"none"};

module.exports = Home32x32;

Home32x32.default = Home32x32;
